var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCflr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#8D91AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5193 14.1326L11.7647 14.125C9.10498 14.125 6.89398 16.2282 6.82428 18.9315C6.8221 19.0034 6.882 19.0633 6.95389 19.0633L16.7084 19.0698C19.3682 19.0709 21.5792 16.9677 21.6489 14.2655C21.651 14.1936 21.5911 14.1337 21.5193 14.1337V14.1326Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4641 6.72833L11.7647 6.7207C9.10498 6.7207 6.89398 8.82387 6.82428 11.5272C6.8221 11.5991 6.882 11.659 6.95389 11.659L21.6532 11.6655C24.313 11.6666 26.524 9.56342 26.5937 6.86121C26.5958 6.78932 26.5359 6.72942 26.4641 6.72942V6.72833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.76322 26.3998C11.1041 26.1416 11.9817 24.8453 11.7235 23.5045C11.4653 22.1636 10.169 21.286 8.82818 21.5442C7.48735 21.8024 6.60971 23.0987 6.86791 24.4395C7.12611 25.7803 8.42239 26.658 9.76322 26.3998Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCflr);
export default __webpack_public_path__ + "static/media/cflr.f39ea0d1007639856c4ae845fcc61f04.svg";
export { ForwardRef as ReactComponent };